<div class="padding">
    <header>
      <h1>{{ data.content.h1 }}</h1>
      <mat-icon matDialogClose>close</mat-icon>
    </header>
  
    <div class="line"></div>
  
    <p>{{ data.content.p }}</p>
    <button
      primary-button="pv-green"
      (keyup.enter)="sendIndex()"
      (click)="sendIndex()"
      matDialogClose
    >
      {{ data.content.button }}
    </button>
  </div>
  